import React, { Fragment, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { CondolenceApi } from "../api/CondelenceApi";
import { DateHelper } from "../helper/DateHelper";
import SubHeader from "./SubHeader";
import noPictureCondoleance from "./../assets/images/Template No Picture Condoleances.png";
import "../App.scss";
import "../index.scss";
import "./PersonList.scss";
import { Each } from "./Util/Each";
import { Show } from "./Util/Show";
import { useWindowDimensions } from "../helper/useWindowDimensions";
import classnames from "classnames";
import { useDebouncedCallback } from "use-debounce";
import { useTranslation } from "react-i18next";
import { Pagination } from "./Pagination/Pagination";

const SEARCH_DEBOUNCE_MS = 400;

function PersonList({ myPluginSettings }) {
  const [inputValue, setInputValue] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [funeralHomeId] = useState(myPluginSettings.funeralHomeId);
  const [pageSize] = useState(myPluginSettings.pageSize);
  const [language] = useState(myPluginSettings.language);
  const [baseUrl] = useState("https://condoleances.be/");
  const { t } = useTranslation();

  CondolenceApi.setApiCredentials(myPluginSettings.token);

  const [loading, setLoading] = useState(false);
  const [condolences, setCondolences] = useState({ groupedData: [], total: 0 });
  const [showError, setShowError] = useState(false);

  const imageSrc = myPluginSettings.pluginUrl + noPictureCondoleance;

  const windowDimensions = useWindowDimensions();

  const debounced = useDebouncedCallback((value) => {
    setSearch(value);
    setPage(1);
  }, SEARCH_DEBOUNCE_MS);

  function filterHandler(f) {
    setInputValue(f);
    debounced(f);
  }

  function createRedirectUrl(name) {
    return baseUrl + name + "?lang=" + language + "&origin=" + funeralHomeId;
  }

  useEffect(() => {
    setLoading(true);
    CondolenceApi.getAllByFuneralHome(page, pageSize, search, funeralHomeId)
      .then((response) => {
        if (response.meta.last_page < page) {
          setPage(1);
        }
        let result = {
          groupedData: response.data.reduce(
            (r, e, i) => (i % 3 ? r[r.length - 1].push(e) : r.push([e])) && r,
            []
          ),
          total: response.meta.total,
        };
        setCondolences(result);
      })
      .catch((_) => {
        setShowError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [funeralHomeId, pageSize, search, page]);

  function getColumnClassName(index, groupLength) {
    const names = ["my-3", "px-3"];
    if (
      !windowDimensions.isSmall &&
      (index !== 2 || index + 1 !== groupLength)
    ) {
      names.push("border-end", "border-dark");
    }
    return classnames(names);
  }

  return (
    <Fragment>
      <SubHeader filterHandler={filterHandler} search={inputValue} />
      <Container className={"mb-5"}>
        <Pagination
          currentPage={page}
          totalCount={condolences.total}
          pageSize={pageSize}
          pluginUrl={myPluginSettings.pluginUrl}
          onPageChange={setPage}
        />
        <Show>
          <Show.When isTrue={showError}>
            <Row className={"justify-content-center"}>
              <Col md={6} className={"text-center"}>
                <h3>{t("error.title")}</h3>
                <p>{t("error.message")}</p>
              </Col>
            </Row>
          </Show.When>
          <Show.Else>
            <Show>
              <Show.When isTrue={loading}>
                <Row className={"justify-content-center mb-4"}>
                  <Spinner animation="border" />
                </Row>
              </Show.When>
              <Show.Else>
                <Each
                  of={condolences.groupedData}
                  render={(group) => (
                    <Row className={"justify-content-center my-2"}>
                      <Each
                        of={group}
                        render={(condolence, index) => (
                          <Col
                            md={"auto"}
                            className={getColumnClassName(index, group.length)}
                          >
                            <div className={"d-flex"}>
                              <Show>
                                <Show.When isTrue={!!condolence.deceasedphoto}>
                                  <img
                                    src={condolence.deceasedphoto}
                                    className={"person-img"}
                                    alt="personImage"
                                    onClick={() => {
                                      // Go to external link in a new tab
                                      window.open(
                                        createRedirectUrl(condolence.alias),
                                        "_blank"
                                      );
                                    }}
                                  />
                                </Show.When>
                                <Show.Else>
                                  <img
                                    src={imageSrc}
                                    className={"person-img"}
                                    alt="condoleanceImage"
                                    cursor="pointer"
                                    onClick={() => {
                                      window.open(
                                        createRedirectUrl(condolence.alias),
                                        "_blank"
                                      );
                                    }}
                                  />
                                </Show.Else>
                              </Show>
                              <div>
                                <span
                                  className="font-style h3 m-2 person-name"
                                  onClick={() => {
                                    window.open(
                                      createRedirectUrl(condolence.alias),
                                      "_blank"
                                    );
                                  }}
                                >
                                  <Show>
                                    <Show.When
                                      isTrue={
                                        condolence.alias.toLowerCase() !==
                                        "familiepoels"
                                      }
                                    >
                                      {condolence.deceased_full_name}
                                    </Show.When>
                                    <Show.Else>Jan en Marijke Poels</Show.Else>
                                  </Show>
                                </span>
                                <br />
                                <Show>
                                  <Show.When
                                    isTrue={
                                      condolence.alias.toLowerCase() !==
                                        "andriesderaeve" &&
                                      condolence.alias.toLowerCase() !==
                                        "familiepoels"
                                    }
                                  >
                                    <div className="align-middle mx-2 dateNoWrap">
                                      <span className={"dateNoWrap"}>
                                        {DateHelper.formatDate(
                                          condolence.date_of_birth
                                        )}
                                      </span>
                                      &nbsp; | &nbsp;
                                      <span className={"dateNoWrap"}>
                                        {DateHelper.formatDate(
                                          condolence.date_of_death,
                                          undefined,
                                          "yyyy-MM-DD"
                                        )}
                                      </span>
                                    </div>
                                  </Show.When>
                                </Show>
                              </div>
                            </div>
                          </Col>
                        )}
                      />
                    </Row>
                  )}
                />
              </Show.Else>
            </Show>
          </Show.Else>
        </Show>
      </Container>
    </Fragment>
  );
}

export default PersonList;
